import { z } from 'zod';
import { BaseSchema } from '../base/base.entity.model';
import * as FlatModels from '../../internal';

export const KeymapLabelSchema = BaseSchema.extend({
  column: z.string().uuid(),
  annotation: z.string().uuid().nullable().default(null),
  order: z.number(),
  index: z.string().max(255),
  text: z.string().max(255).nullable().default(null),
});

export type KeymapLabel = z.infer<typeof KeymapLabelSchema>;

export const KeymapLabelEntityQueryResultSchema = FlatModels.EntityControlModels.EntityQueryResultSchema.extend({
  entity: KeymapLabelSchema,
});

export type KeymapLabelEntityQueryResult = z.infer<typeof KeymapLabelEntityQueryResultSchema>;
